/* eslint-disable max-len */
import { gql, useQuery } from '@apollo/client';

const getSubcategoriesForCategory = gql`
  query CategorySubcategories($categoryId: String!) {
    navigationCategory(categoryId: $categoryId) {
      categoryId
      hideChildren
      name
      url
      dropdownTopValue
      navigationSubCategories {
        categoryId
        displayType
        hideCategory
        name
        url
      }
    }
  }
`;

/**
 * Custom React hook to fetch and process subcategories for a given parent category,
 * and generate dropdown options for category navigation.
 *
 * @param {Object} params - Parameters for the hook.
 * @param {string} params.parentCategoryId - The ID of the parent category (required).
 * @param {string} params.currentCategoryId - The ID of the currently selected category.
 *
 * @returns {Object} An object containing:
 *   @property {Array<{label: string, value: string}>} dropdownOptions - The dropdown options for categories.
 *   @property {{value: string, index: number}|undefined} dropdownDefaultInfo - The default dropdown option info if current category matches a subcategory.
 *   @property {function} handleChange - Handler for dropdown change event.
 */
const useCategoryDropdown = ({ parentCategoryId, currentCategoryId = '' }) => {
  const { data } = useQuery(getSubcategoriesForCategory, {
    variables: {
      categoryId: parentCategoryId,
    },
  });

  const regularSubcategories = [];
  const clearanceSubcategories = [];
  const featuredSubcategories = [];
  let dropdownDefaultInfo;

  if (!data?.navigationCategory?.hideChildren) {
    data?.navigationCategory?.navigationSubCategories.forEach(({
      categoryId, displayType, hideCategory, name, url,
    }, index) => {
      if (!hideCategory) {
        switch (displayType) {
          case 'regular':
            regularSubcategories.push({ label: name, value: url });
            break;
          case 'clearance':
            clearanceSubcategories.push({ label: name, value: url });
            break;
          case 'featured':
            featuredSubcategories.push({ label: name, value: url });
            break;
          default:
            break;
        }

        // Check if subcategory matches current page to use as default option
        if (categoryId === currentCategoryId) {
          dropdownDefaultInfo = { value: url, index };
        }
      }
    });
  }

  const dropdownOptions = [
    ...(data?.navigationCategory?.dropdownTopValue ? [{ label: `${data.navigationCategory.dropdownTopValue}`, value: data?.navigationCategory?.url }] : []),
    ...regularSubcategories,
    ...clearanceSubcategories,
    ...featuredSubcategories,
  ];

  const handleChange = (e) => {
    window.location.href = e.target.value;
  };
  return {
    dropdownOptions,
    dropdownDefaultInfo,
    handleChange,
  };
};

export default useCategoryDropdown;
